import "./App.scss";

import Home from "./pages/Home";

const App = () => {
    return (
        <div className="app-container">
            <Home />
        </div>
    );
};

export default App;
